<template>
  <div class="p-5">
    <div class="mb-5">
      <h2>Hei {{ userProfile.name }}</h2>
      <p class="mt-4">
        Vi har nå sendt dine inntektsopplysninger for 2020 til Skatteetaten.
        <template v-if="landlordsThatNeedACK && landlordsThatNeedACK.length">
          Du kan fremdeles rette informasjonen om deg og dine leieforhold, men disse vil da gjelde for 2021.
        </template>
      </p>
      <p>Årsoppgaven for 2020 sendes per epost den 25.2.2021, og vil også bli gjort tilgjengelig fra løsningen.</p>
      <p>Endringer som knytter seg til 2020 må heretter gjøres gjennom Altinn.no når skattemeldingen kommer.</p>
      <p>
        For mer informasjon, se
        <a href="https://www.husleie.no/utleier/skatterapportering" target="_blank"
          >https://www.husleie.no/utleier/skatterapportering</a
        >.
      </p>
    </div>

    <BlockContainer class="p-5" v-if="landlordsThatNeedACK && landlordsThatNeedACK.length">
      <hl-Accordion>
        <hl-AccordionItem
          v-for="(landlord, idx) in landlordsThatNeedACK"
          :key="landlord.id"
          :title="landlord.meta.needsAcknowledgement.landlordName"
          :idx="idx"
          icon="budicon-solid budicon-solid-alert-sign text-warning"
        >
          <TaxReportLandlordSummary :landlord="landlord" @updated="refetchLandlordProfiles"></TaxReportLandlordSummary>

          <hl-Accordion class="mt-4">
            <hl-AccordionItem
              v-for="(rentalObject, j) in landlord.meta.needsAcknowledgement.rentalObjects"
              :key="rentalObject.id"
              :title="rentalObject.name"
              :idx="j"
              icon="budicon-solid budicon-solid-alert-sign text-warning"
              @expanded="getRentalObject(landlord.id, rentalObject.id)"
            >
              <div>
                <TaxReportRentalObjectSummary
                  v-if="getRentalObjectById(rentalObject.id)"
                  :rentalObject="getRentalObjectById(rentalObject.id)"
                  :issues="rentalObject.issues"
                  :landlordId="landlord.id"
                  :token="landlord.meta.needsAcknowledgement.token"
                  :landlordName="landlord.meta.needsAcknowledgement.landlordName"
                  @updated="refetchLandlordProfiles"
                />
              </div>
            </hl-AccordionItem>
          </hl-Accordion>
        </hl-AccordionItem>
      </hl-Accordion>
    </BlockContainer>
    <p>
      <em>Alle data vi har om deg og dine leieforhold er oppdatert</em>
    </p>
  </div>
</template>

<script>
import BlockContainer from '@/components/BlockContainer';
import husleieapi from '@modules/husleie-api';
import TaxReportRentalObjectSummary from '@/components/tax-report/TaxReportRentalObjectSummary';
import TaxReportLandlordSummary from '@/components/tax-report/TaxReportLandlordSummary';
import { mapActions, mapGetters } from 'vuex';
import Accordion from '@modules/husleie-framework/src/components/Accordion.vue';
import AccordionItem from '@modules/husleie-framework/src/components/AccordionItem.vue';

export default {
  components: {
    BlockContainer,
    TaxReportRentalObjectSummary,
    TaxReportLandlordSummary,
    'hl-Accordion': Accordion,
    'hl-AccordionItem': AccordionItem,
  },

  data() {
    return {
      rentalObjects: [],
    };
  },
  computed: {
    ...mapGetters({
      userProfile: 'getUserProfile',
      getLandlordProfilesMeta: 'getLandlordProfilesMeta',
    }),
    accordionItems() {
      return this.meta.needs_acknowledgment.landlords;
    },

    landlordsThatNeedACK() {
      if (this.getLandlordProfilesMeta == null) return null;
      return this.getLandlordProfilesMeta.filter(
        landlord => Object.keys(landlord.meta.needsAcknowledgement).length !== 0
      );
    },
  },

  methods: {
    ...mapActions(['loadLandlordProfiles']),

    isRentalObjectLoaded(rentalObjectId) {
      if (this.rentalObjects.length === 0) return false;
      return this.rentalObjects.find(rentalObject => rentalObject.id === rentalObjectId);
    },

    // We don't fetch the rentalObjects that we have already fetched
    getRentalObject(landlordId, rentalObjectId) {
      if (this.isRentalObjectLoaded(rentalObjectId)) {
        return this.isRentalObjectLoaded(rentalObjectId);
      } else {
        this.fetchRentalObject(landlordId, rentalObjectId);
      }
    },

    async fetchRentalObject(landlordId, rentalObjectId) {
      const hlApi = new husleieapi();

      const opts = {
        tenancyStatus: ['active', 'resigned'],
        extended: true,
      };

      return new Promise((resolve, reject) => {
        hlApi.call('RentalObjectApi.getRentalObject', landlordId, rentalObjectId, opts, (error, data) => {
          if (error) {
            this.$toast('Kunne ikke hente leieobjektet', 'error');
            reject(error);
          } else {
            console.log('success', data);
            this.rentalObjects.push(data);
            resolve();
          }
        });
      });
    },

    getRentalObjectById(id) {
      return this.rentalObjects.find(rentalObject => rentalObject.id === id);
    },

    refetchLandlordProfiles() {
      this.loadLandlordProfiles();
    },
  },

  mounted() {
    /* if (this.getLandlordProfilesMeta.length === 0) {
      this.loadLandlordProfiles();
    } */
  },
};
</script>
